module.exports = __webpack_public_path__ + "img/male-newborn-figure.7ba3bd49.svg";